import React from 'react';
import Reveal, { RevealWords } from './Reveal';

export default function SectionHeading({
  eyebrow,
  title,
  lead,
  align = 'left',
  size = 'd2',
  children,
}) {
  const centered = align === 'center';
  return (
    <div
      className={`stack stack-sm${centered ? ' text-center' : ''}`}
      style={centered ? { alignItems: 'center' } : undefined}
    >
      {eyebrow ? (
        <Reveal as="p" className={`eyebrow${centered ? ' is-centered' : ''}`}>
          {eyebrow}
        </Reveal>
      ) : null}
      <h2 className={`display brand ${size}`} style={{ maxWidth: centered ? '20ch' : '18ch' }}>
        <RevealWords text={title} />
      </h2>
      {lead ? (
        <Reveal as="p" className="lead" delay={0.15} style={centered ? { marginInline: 'auto' } : undefined}>
          {lead}
        </Reveal>
      ) : null}
      {children}
    </div>
  );
}
